var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[(!_vm.isWhitelabeled)?_c('endorsement-pane'):_vm._e(),_c('content-pane')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }